import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 信用评价服务-查询服务
 */
export class CreditEvaQueryController {
    constructor() {
        this.baseurl = 'creditEvaQueryController.assx/';
    }

    /**
     * 获取业务单业务流程信息
     * token:String, docCode:String
     */
    getCreditEvaApplyInfo(token, docCode){
        return request.post(this.baseurl + 'getCreditEvaApplyInfo', Qs.stringify({ token:token, docCode:docCode }));
    }
    /**
     * 项目负责人基础信息
     * token:String, wyqydm:String
     */
    getManagerAndCompanyInformation(token, wyqydm){
        return request.post(this.baseurl + 'getManagerAndCompanyInformation', Qs.stringify({ token:token, wyqydm:wyqydm }));
    }
    
    /**
     * 
     * token:String, wyqydm:String
     */
    getManagerAndCompanyInfo(token, wyqydm){
        return request.post(this.baseurl + 'getManagerAndCompanyInfo', Qs.stringify({ token:token, wyqydm:wyqydm }));
    }

    /**
     * 
     * openId:String, token:String, mob:String, orgCode:String, type:String
     */
    getCreditEvaInformationVO(openId, token, mob, orgCode, type){
        return request.post(this.baseurl + 'getCreditEvaInformationVO', Qs.stringify({ openId:openId, token:token, mob:mob, orgCode:orgCode, type:type }));
    }

    /**
     * 
     * wyqydm:String, startIndex:int, maxSize:int
     */
    getManagerPersonRoleByEaAreaCode_builtBureauWebsite(wyqydm, startIndex, maxSize){
        return request.post(this.baseurl + 'getManagerPersonRoleByEaAreaCode_builtBureauWebsite', Qs.stringify({ wyqydm:wyqydm, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 获取历史数据详情
     * token:String, keyId:String
     */
    getCreditEvaHistoryRecordsDetail(token, keyId){
        return request.post(this.baseurl + 'getCreditEvaHistoryRecordsDetail', Qs.stringify({ token:token, keyId:keyId }));
    }

    /**
     * 获取基础信息详情（穿透项目经理）
     * token:String, mangerName:String, mangerTel:String, orgCode:String, dateTime:Date, bodyType:int
     */
    getCreditEvaBasicInfoByMange(token, mangerName, mangerTel, orgCode, dateTime, bodyType){
        return request.post(this.baseurl + 'getCreditEvaBasicInfoByMange', Qs.stringify({ token:token, mangerName:mangerName, mangerTel:mangerTel, orgCode:orgCode, dateTime:dateTime, bodyType:bodyType }));
    }

    /**
     * 
     * wyqydm:String, startIndex:int, maxSize:int
     */
    getCreditEvaBasicEvaluationFeedbackList(wyqydm, startIndex, maxSize){
        return request.post(this.baseurl + 'getCreditEvaBasicEvaluationFeedbackList', Qs.stringify({ wyqydm:wyqydm, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 
     * companyCode:String, startIndex:int, maxSize:int
     */
    getCeEnterpriseReportList(companyCode, startIndex, maxSize){
        return request.post(this.baseurl + 'getCeEnterpriseReportList', Qs.stringify({ companyCode:companyCode, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 
     * token:String, eaAreaCode:String, eaAreaName:String, creditBodyType:String, isScoreAsc:int, totalScore_l:String, totalScore_r:String, managerName:String, companyName:String, startIndex:int, maxSize:int
     */
    // getCreditEvaBasicInfoManagerVOList(token, eaAreaCode, eaAreaName, creditBodyType, isScoreAsc, totalScore_l, totalScore_r, managerName, companyName, startIndex, maxSize){
    //     return request.post(this.baseurl + 'getCreditEvaBasicInfoManagerVOList', Qs.stringify({ token:token, eaAreaCode:eaAreaCode, eaAreaName:eaAreaName, creditBodyType:creditBodyType, isScoreAsc:isScoreAsc, totalScore_l:totalScore_l, totalScore_r:totalScore_r, managerName:managerName, companyName:companyName, startIndex:startIndex, maxSize:maxSize }));
    // }

    /**
     * 
     * companyCode:String, mob:String, managerName:String, creditBodyType:int
     */
    getCreditEvaBasicInfoVOByRole_builtBureauWebsite(companyCode, mob, managerName, creditBodyType){
        return request.post(this.baseurl + 'getCreditEvaBasicInfoVOByRole_builtBureauWebsite', Qs.stringify({ companyCode:companyCode, mob:mob, managerName:managerName, creditBodyType:creditBodyType }));
    }

    /**
     * 
     * wyqydm:String
     */
    getCreditEvaBasicEva_builtBureauWebsite(wyqydm){
        return request.post(this.baseurl + 'getCreditEvaBasicEva_builtBureauWebsite', Qs.stringify({ wyqydm:wyqydm }));
    }

    /**
     * 
     * companyName:String, companyCode:String, eaAreaName:String, managerName:String, orderByItem:int, creditBodyType:int, startIndex:int, maxSize:int, managerNameOrCompanyName:String
     */
    getCreditEvaSummaryVOList_builtBureauWebsite(companyName, companyCode, eaAreaName, managerName, orderByItem, creditBodyType, startIndex, maxSize, managerNameOrCompanyName){
        return request.post(this.baseurl + 'getCreditEvaSummaryVOList_builtBureauWebsite', Qs.stringify({ companyName:companyName, companyCode:companyCode, eaAreaName:eaAreaName, managerName:managerName, orderByItem:orderByItem, creditBodyType:creditBodyType, startIndex:startIndex, maxSize:maxSize, managerNameOrCompanyName:managerNameOrCompanyName }));
    }

    /**
     * 获取风险名单过程详情倒叙最新数据
     * token:String, docCode:String, sign:String
     */
    getRiskCreditEvaApplyProcessDetailDescByDocCode(token, docCode, sign){
        return request.post(this.baseurl + 'getRiskCreditEvaApplyProcessDetailDescByDocCode', Qs.stringify({ token:token, docCode:docCode, sign:sign }));
    }

    /**
     * 
     * token:String, wyqydm:String, startIndex:int, maxSize:int
     */
    getCreditEvaBasicCommonAccountList(token, wyqydm, startIndex, maxSize){
        return request.post(this.baseurl + 'getCreditEvaBasicCommonAccountList', Qs.stringify({ token:token, wyqydm:wyqydm, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 
     * mob:String, orgCode:String, type:String
     */
    getCreditEvaInformationVO_builtBureauWebsite(mob, orgCode, type){
        return request.post(this.baseurl + 'getCreditEvaInformationVO_builtBureauWebsite', Qs.stringify({ mob:mob, orgCode:orgCode, type:type }));
    }

    /**
     * 
     * wyqydm:String
     */
    getCreditEvaBasicEvaluationFeedbackInfo(wyqydm){
        return request.post(this.baseurl + 'getCreditEvaBasicEvaluationFeedbackInfo', Qs.stringify({ wyqydm:wyqydm }));
    }

    /**
     * 获取基础信息详情
     * keyId:String, dateTime:Date, orgCode:String, personName:String, personTel:String, bodyType:int
     */
    getCreditEvaBasicInfo_builtBureauWebsite(keyId, dateTime, orgCode, personName, personTel, bodyType){
        return request.post(this.baseurl + 'getCreditEvaBasicInfo_builtBureauWebsite', Qs.stringify({ keyId:keyId, dateTime:dateTime, orgCode:orgCode, personName:personName, personTel:personTel, bodyType:bodyType }));
    }

    /**
     * 获取分数列表
     * token:String, startDateTime:Date, endDateTime:Date, orgName:String, mangerName:String, eaAreaName:String, startIndex:int, maxSize:int, totalCount:boolean, orderBody:int, desc:Boolean, bodyType:int, type:int
     */
    getCreditEvaRankingList(token, startDateTime, endDateTime, orgName, mangerName, eaAreaName, startIndex, maxSize, totalCount, orderBody, desc, bodyType, type,cantonCode){
        return request.post(this.baseurl + 'getCreditEvaRankingList', Qs.stringify({ token:token, startDateTime:startDateTime, endDateTime:endDateTime, orgName:orgName, mangerName:mangerName, eaAreaName:eaAreaName, startIndex:startIndex, maxSize:maxSize, totalCount:totalCount, orderBody:orderBody, desc:desc, bodyType:bodyType, type:type ,cantonCode:cantonCode}));
    }

    /**
     * 获取业务单内容
     * token:String, docCode:String
     */
    getBusinessDocDetail(token, docCode){
        return request.post(this.baseurl + 'getBusinessDocDetail', Qs.stringify({ token:token, docCode:docCode }));
    }

    /**
     * 获取排名信息详情（穿透项目经理）
     * token:String, mangerName:String, mangerTel:String, orgCode:String, dateTime:Date, bodyType:int
     */
    getCreditEvaRankingByMange(token, mangerName, mangerTel, orgCode, dateTime, bodyType){
        return request.post(this.baseurl + 'getCreditEvaRankingByMange', Qs.stringify({ token:token, mangerName:mangerName, mangerTel:mangerTel, orgCode:orgCode, dateTime:dateTime, bodyType:bodyType }));
    }

    /**
     * 
     * token:String, wyqydm:String, startIndex:int, maxSize:int
     */
    getManagerPersonRoleByEaAreaCode(token, wyqydm, startIndex, maxSize){
        return request.post(this.baseurl + 'getManagerPersonRoleByEaAreaCode', Qs.stringify({ token:token, wyqydm:wyqydm, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 
     * wyqydm:String
     */
    getCreditEvaBasicPublicInfo(wyqydm){
        return request.post(this.baseurl + 'getCreditEvaBasicPublicInfo', Qs.stringify({ wyqydm:wyqydm }));
    }

    /**
     * 
     * wyqydm:String, startIndex:int, maxSize:int
     */
    getCreditEvaBasicSafeCheckList_builtBureauWebsite(wyqydm, startIndex, maxSize){
        return request.post(this.baseurl + 'getCreditEvaBasicSafeCheckList_builtBureauWebsite', Qs.stringify({ wyqydm:wyqydm, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 
     * wyqydm:String, startIndex:int, maxSize:int
     */
    getCreditEvaBasicTrainList_builtBureauWebsite(wyqydm, startIndex, maxSize){
        return request.post(this.baseurl + 'getCreditEvaBasicTrainList_builtBureauWebsite', Qs.stringify({ wyqydm:wyqydm, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 获取良好过程详情倒叙最新数据
     * token:String, docCode:String, sign:String
     */
    getGoodCreditEvaApplyProcessDetailDescByDocCode(token, docCode, sign){
        return request.post(this.baseurl + 'getGoodCreditEvaApplyProcessDetailDescByDocCode', Qs.stringify({ token:token, docCode:docCode, sign:sign }));
    }

    /**
     * 
     * openId:String, token:String
     */
    getCreditEvaBasicInfoVOByRole(openId, token){
        return request.post(this.baseurl + 'getCreditEvaBasicInfoVOByRole', Qs.stringify({ openId:openId, token:token }));
    }

    /**
     * 
     * wyqydm:String
     */
    getCreditEvaBasicNotice_builtBureauWebsite(wyqydm){
        return request.post(this.baseurl + 'getCreditEvaBasicNotice_builtBureauWebsite', Qs.stringify({ wyqydm:wyqydm }));
    }

    /**
     * 获取不良过程详情倒叙最新数据
     * token:String, docCode:String, sign:String
     */
    getBadCreditEvaApplyProcessDetailDescByDocCode(token, docCode, sign){
        return request.post(this.baseurl + 'getBadCreditEvaApplyProcessDetailDescByDocCode', Qs.stringify({ token:token, docCode:docCode, sign:sign }));
    }

    /**
     * 
     * token:String, wyqydm:String
     */
    getCreditEvaBasicNotice(token, wyqydm){
        return request.post(this.baseurl + 'getCreditEvaBasicNotice', Qs.stringify({ token:token, wyqydm:wyqydm }));
    }

    /**
     * 
     * wyqydm:String, startIndex:int, maxSize:int
     */
    getCreditEvaBasicCommonAccountList_builtBureauWebsite(wyqydm, startIndex, maxSize){
        return request.post(this.baseurl + 'getCreditEvaBasicCommonAccountList_builtBureauWebsite', Qs.stringify({ wyqydm:wyqydm, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 获取基础信息列表
     * token:String, thisDate:Date, orgName:String, mangerName:String, eaAreaName:String, orgCode:String, mangerTel:String, startIndex:int, maxSize:int, totalCount:boolean, type:int, option:int, bodyType:int
     */
    getCreditEvaBasicInfoList_public(token, thisDate, orgName, mangerName, eaAreaName, orgCode, mangerTel, startIndex, maxSize, totalCount, type, option, bodyType){
        return request.post(this.baseurl + 'getCreditEvaBasicInfoList_public', Qs.stringify({ token:token, thisDate:thisDate, orgName:orgName, mangerName:mangerName, eaAreaName:eaAreaName, orgCode:orgCode, mangerTel:mangerTel, startIndex:startIndex, maxSize:maxSize, totalCount:totalCount, type:type, option:option, bodyType:bodyType }));
    }

    /**
     * 获取异议过程详情倒叙最新数据
     * token:String, docCode:String, sign:String
     */
    getDissentCreditEvaApplyProcessDetailDescByDocCode(token, docCode, sign){
        return request.post(this.baseurl + 'getDissentCreditEvaApplyProcessDetailDescByDocCode', Qs.stringify({ token:token, docCode:docCode, sign:sign }));
    }

    /**
     * 获取分数信息详情
     * token:String, keyId:String, dateTime:Date, bodyType:int, type:int
     */
    getCreditEvaRanking(token, keyId, dateTime, bodyType, type){
        return request.post(this.baseurl + 'getCreditEvaRanking', Qs.stringify({ token:token, keyId:keyId, dateTime:dateTime, bodyType:bodyType, type:type }));
    }

    /**
     * 获取历史数据列表
     * token:String, docCode:String, isDelete:boolean, startIndex:int, maxSize:int, resultTotalCount:boolean, option:int
     */
    getCreditEvaHistoryRecordsList(token, docCode, isDelete, startIndex, maxSize, resultTotalCount, option){
        return request.post(this.baseurl + 'getCreditEvaHistoryRecordsList', Qs.stringify({ token:token, docCode:docCode, isDelete:isDelete, startIndex:startIndex, maxSize:maxSize, resultTotalCount:resultTotalCount, option:option }));
    }

    /**
     * 
     * orgCode:String, orgName:String, creditBodyType:String, isScoreAsc:int, startIndex:int, maxSize:int
     */
    getCreditEvaBasicInfoCompanyVOList_builtBureauWebsite(orgCode, orgName, creditBodyType, isScoreAsc, startIndex, maxSize){
        return request.post(this.baseurl + 'getCreditEvaBasicInfoCompanyVOList_builtBureauWebsite', Qs.stringify({ orgCode:orgCode, orgName:orgName, creditBodyType:creditBodyType, isScoreAsc:isScoreAsc, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 
     * eaAreaCode:String, eaAreaName:String, creditBodyType:String, isScoreAsc:int, totalScore_l:String, totalScore_r:String, managerName:String, companyName:String, startIndex:int, maxSize:int, managerNameOrCompanyName:String
     */
    getCreditEvaBasicInfoManagerVOList_builtBureauWebsite(eaAreaCode, eaAreaName, creditBodyType, isScoreAsc, totalScore_l, totalScore_r, managerName, companyName, startIndex, maxSize, managerNameOrCompanyName){
        return request.post(this.baseurl + 'getCreditEvaBasicInfoManagerVOList_builtBureauWebsite', Qs.stringify({ eaAreaCode:eaAreaCode, eaAreaName:eaAreaName, creditBodyType:creditBodyType, isScoreAsc:isScoreAsc, totalScore_l:totalScore_l, totalScore_r:totalScore_r, managerName:managerName, companyName:companyName, startIndex:startIndex, maxSize:maxSize, managerNameOrCompanyName:managerNameOrCompanyName }));
    }

    /**
     * 获取基础信息列表
     * thisDate:Date, orgName:String, mangerName:String, eaAreaName:String, orgCode:String, mangerTel:String, startIndex:int, maxSize:int, totalCount:boolean, type:int, option:int, bodyType:int
     */
    getCreditEvaBasicInfoList_builtBureauWebsite(thisDate, orgName, mangerName, eaAreaName, orgCode, mangerTel, startIndex, maxSize, totalCount, type, option, bodyType){
        return request.post(this.baseurl + 'getCreditEvaBasicInfoList_builtBureauWebsite', Qs.stringify({ thisDate:thisDate, orgName:orgName, mangerName:mangerName, eaAreaName:eaAreaName, orgCode:orgCode, mangerTel:mangerTel, startIndex:startIndex, maxSize:maxSize, totalCount:totalCount, type:type, option:option, bodyType:bodyType }));
    }

    /**
     * 
     * wyqydm:String
     */
    getManagerAndCompanyInfo_builtBureauWebsite(wyqydm){
        return request.post(this.baseurl + 'getManagerAndCompanyInfo_builtBureauWebsite', Qs.stringify({ wyqydm:wyqydm }));
    }

    /**
     * 获取基础信息详情
     * token:String, keyId:String, dateTime:Date, orgCode:String, personName:String, personTel:String, bodyType:int
     */
    getCreditEvaBasicInfo(token, keyId, dateTime, orgCode, personName, personTel, bodyType){
        return request.post(this.baseurl + 'getCreditEvaBasicInfo', Qs.stringify({ token:token, keyId:keyId, dateTime:dateTime, orgCode:orgCode, personName:personName, personTel:personTel, bodyType:bodyType }));
    }

    /**
     * 获取激励名单对外公示列表
     * year:Integer, search:String, startIndex:int, size:int, page:boolean
     */
    getExcitationExternalList(year, search, startIndex, size, page){
        return request.post(this.baseurl + 'getExcitationExternalList', Qs.stringify({ year:year, search:search, startIndex:startIndex, size:size, page:page }));
    }

    /**
     * 
     * openId:String, token:String, companyCode:String, mob:String, managerName:String, creditBodyType:int
     */
    getCreditEvaBasicInfoVOByRole_public(openId, token, companyCode, mob, managerName, creditBodyType){
        return request.post(this.baseurl + 'getCreditEvaBasicInfoVOByRole_public', Qs.stringify({ openId:openId, token:token, companyCode:companyCode, mob:mob, managerName:managerName, creditBodyType:creditBodyType }));
    }

    /**
     * 
     * openId:String, token:String, companyName:String, companyCode:String, eaAreaName:String, managerName:String, orderByItem:int, creditBodyType:int, startIndex:int, maxSize:int
     */
    getCreditEvaSummaryVOList(openId, token, companyName, companyCode, eaAreaName, managerName, orderByItem, creditBodyType, startIndex, maxSize){
        return request.post(this.baseurl + 'getCreditEvaSummaryVOList', Qs.stringify({ openId:openId, token:token, companyName:companyName, companyCode:companyCode, eaAreaName:eaAreaName, managerName:managerName, orderByItem:orderByItem, creditBodyType:creditBodyType, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 
     * phone:String, eaAreaCode:String, startIndex:int, maxSize:int
     */
    getCreditEvaNotificationResponseRateVOList(phone, eaAreaCode, startIndex, maxSize){
        return request.post(this.baseurl + 'getCreditEvaNotificationResponseRateVOList', Qs.stringify({ phone:phone, eaAreaCode:eaAreaCode, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 获取分数信息详情
     * keyId:String, dateTime:Date, bodyType:int, type:int
     */
    getCreditEvaRanking_builtBureauWebsite(keyId, dateTime, bodyType, type){
        return request.post(this.baseurl + 'getCreditEvaRanking_builtBureauWebsite', Qs.stringify({ keyId:keyId, dateTime:dateTime, bodyType:bodyType, type:type }));
    }

    /**
     * 
     * token:String, wyqydm:String
     */
    getCreditEvaBasicPublic(token, wyqydm){
        return request.post(this.baseurl + 'getCreditEvaBasicPublic', Qs.stringify({ token:token, wyqydm:wyqydm }));
    }

    /**
     * 
     * token:String, wyqydm:String, startIndex:int, maxSize:int
     */
    getCreditEvaBasicSafeCheckList(token, wyqydm, startIndex, maxSize){
        return request.post(this.baseurl + 'getCreditEvaBasicSafeCheckList', Qs.stringify({ token:token, wyqydm:wyqydm, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 
     * token:String, wyqydm:String, startIndex:int, maxSize:int
     */
    getCreditEvaBasicTrainList(token, wyqydm, startIndex, maxSize){
        return request.post(this.baseurl + 'getCreditEvaBasicTrainList', Qs.stringify({ token:token, wyqydm:wyqydm, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 住建局官网，获取分数列表
     * startDateTime:Date, endDateTime:Date, orgName:String, mangerName:String, eaAreaName:String, startIndex:int, maxSize:int, totalCount:boolean, orderBody:int, desc:Boolean, bodyType:int, type:int
     */
    getCreditEvaRankingList_builtBureauWebsite(startDateTime, endDateTime, orgName, mangerName, eaAreaName, startIndex, maxSize, totalCount, orderBody, desc, bodyType, type){
        return request.post(this.baseurl + 'getCreditEvaRankingList_builtBureauWebsite', Qs.stringify({ startDateTime:startDateTime, endDateTime:endDateTime, orgName:orgName, mangerName:mangerName, eaAreaName:eaAreaName, startIndex:startIndex, maxSize:maxSize, totalCount:totalCount, orderBody:orderBody, desc:desc, bodyType:bodyType, type:type }));
    }

    /**
     * 
     * openId:String, token:String, managerName:String, eaAreaName:String, startIndex:int, maxSize:int
     */
    getCreditEvaBasicInfoScoreResultVO(openId, token, managerName, eaAreaName, startIndex, maxSize){
        return request.post(this.baseurl + 'getCreditEvaBasicInfoScoreResultVO', Qs.stringify({ openId:openId, token:token, managerName:managerName, eaAreaName:eaAreaName, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 获取基础信息列表
     * token:String, thisDate:Date, orgName:String, mangerName:String, eaAreaName:String, orgCode:String, mangerTel:String, startIndex:int, maxSize:int, totalCount:boolean, type:int, option:int, bodyType:int
     */
    getCreditEvaBasicInfoList(token, thisDate, orgName, mangerName, eaAreaName, orgCode, mangerTel, startIndex, maxSize, totalCount, type, option, bodyType){
        return request.post(this.baseurl + 'getCreditEvaBasicInfoList', Qs.stringify({ token:token, thisDate:thisDate, orgName:orgName, mangerName:mangerName, eaAreaName:eaAreaName, orgCode:orgCode, mangerTel:mangerTel, startIndex:startIndex, maxSize:maxSize, totalCount:totalCount, type:type, option:option, bodyType:bodyType }));
    }

    /**
     * 获取上一年度评价等级
     * token:String, bodyType:int
     */
    getCreditEvaRankingLevel(token, bodyType){
        return request.post(this.baseurl + 'getCreditEvaRankingLevel', Qs.stringify({ token:token, bodyType:bodyType }));
    }

    /**
     * 
     * wyqydm:String
     */
    getCreditEvaBasicPublic_builtBureauWebsite(wyqydm){
        return request.post(this.baseurl + 'getCreditEvaBasicPublic_builtBureauWebsite', Qs.stringify({ wyqydm:wyqydm }));
    }

    /**
     * 
     * token:String, orgCode:String, orgName:String, creditBodyType:String, isScoreAsc:int, startIndex:int, maxSize:int
     */
    getCreditEvaBasicInfoCompanyVOList(token, orgCode, orgName, creditBodyType, isScoreAsc, startIndex, maxSize){
        return request.post(this.baseurl + 'getCreditEvaBasicInfoCompanyVOList', Qs.stringify({ token:token, orgCode:orgCode, orgName:orgName, creditBodyType:creditBodyType, isScoreAsc:isScoreAsc, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 
     * areaCode:String
     */
    getCommunityEvaluateListByAreaCode(areaCode){
        return request.post(this.baseurl + 'getCommunityEvaluateListByAreaCode', Qs.stringify({ areaCode:areaCode }));
    }

    /**
     * 
     * wyqydm:String, startIndex:int, maxSize:int
     */
    getCreditEvaBasicContractList_builtBureauWebsite(wyqydm, startIndex, maxSize){
        return request.post(this.baseurl + 'getCreditEvaBasicContractList_builtBureauWebsite', Qs.stringify({ wyqydm:wyqydm, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 
     * token:String, wyqydm:String
     */
    getCreditEvaBasicEva(token, wyqydm){
        return request.post(this.baseurl + 'getCreditEvaBasicEva', Qs.stringify({ token:token, wyqydm:wyqydm }));
    }

    /**
     * 
     * token:String, wyqydm:String, startIndex:int, maxSize:int
     */
    getCreditEvaBasicContractList(token, wyqydm, startIndex, maxSize){
        return request.post(this.baseurl + 'getCreditEvaBasicContractList', Qs.stringify({ token:token, wyqydm:wyqydm, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 
     * nickName:String, eaAreaCode:String
     */
    getCreditEvaNotificationResponseRateHeadVO(nickName, eaAreaCode){
        return request.post(this.baseurl + 'getCreditEvaNotificationResponseRateHeadVO', Qs.stringify({ nickName:nickName, eaAreaCode:eaAreaCode }));
    }
}